window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.form-section-toggle').length) {
    import('./_form-section-toggle.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
